<template>
  <div class="animated fadeIn bgV2">
    <b-row>
      <b-col md="12">
        <gofix-tab
          class="mt-3"
          :data="tabData">
          <template slot="gofixTab:right">
            <gofix-button
              @click="updateItem"
              label="SAVE"
              :disabled="$disabledCreateOrUpdate(this.sorItem, $accessModule.sor)"></gofix-button>
          </template>
          <template slot="gofixTab:basic-info">
            <b-form v-bind:class="{'run-loading':Loadings.popup}">
              <gofix-card classContent="mt-4 mb-0">
                <b-row>
                  <b-col md="4">
                    <gofix-form-input label="SOR Code" v-model="sorItem.sor_code" required show-icon-required></gofix-form-input>
                  </b-col>
                  <b-col md="4">
                    <!--Sor group-->
                    <gofix-form-tree
                      label="SOR Group"
                      :multiple="false"
                      :options="groups"
                      :normalizer="normalizerGroup"
                      :default-expand-level="2"
                      v-model="sorItem.sor_group"
                      placeholder=""
                      valueFormat="object"
                      required
                      show-icon-required>
                    </gofix-form-tree>
                  </b-col>
                  <b-col md="2">
                    <gofix-form-input-date
                      v-model="sorItem._start_date"
                      required
                      label="Start Date">
                    </gofix-form-input-date>
                  </b-col>
                </b-row>
              </gofix-card>
              <gofix-card classContent="mt-4 mb-0">
                <b-row>
                  <b-col md="4">
                    <gofix-form-tree
                      label="Service Category"
                      required
                      :default-expand-level="1"
                      :multiple="false"
                      :options="Services"
                      :load-options="loadOptionsService"
                      search-nested
                      :normalizer="normalizerService"
                      valueFormat="object"
                      v-model="sorItem.service_category"
                      placeholder=""
                      show-icon-required>
                    </gofix-form-tree>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="8">
                    <gofix-form-input label="Description 01" v-model="sorItem.description_one"></gofix-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="8">
                    <gofix-form-input label="Description 02" v-model="sorItem.description_two"></gofix-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="4">
                    <gofix-form-dropdown
                      label="Work Type"
                      :options="['Corrective','Reactive']"
                      v-model="sorItem.work_type">
                    </gofix-form-dropdown>
                  </b-col>
                  <b-col md="4">
                    <gofix-form-input label="Fault Type" v-model="sorItem.fault_type"></gofix-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="4">
                    <gofix-form-dropdown
                      label="Brand"
                      vLabel="name"
                      :options="brands"
                      :reduce="option => option.name"
                      v-model="sorItem.brand">
                    </gofix-form-dropdown>
                  </b-col>
                  <b-col md="4">
                    <gofix-form-supplier 
                      label="Default Supplier" class="m-0"
                      :contract-id="Number($route.params.id)"
                      :service-category-id="sorItem.service_category && sorItem.service_category.id ? sorItem.service_category.id : null"
                      v-model="sorItem.default_supplier">
                    </gofix-form-supplier>
                  </b-col>
                </b-row>
              </gofix-card>
              <gofix-card classContent="mt-4 mb-0">
                <b-row>
                  <b-col md="4">
                    <gofix-form-input-number
                      :disabled="ClientContractID.status ==='Active' || ClientContractID.status ==='Expired' || ClientContractID.status ==='Terminated' || ClientContractID.status ==='Reopening'"
                      label="Unit Price"
                      required
                      v-model="sorItem.unit_price_tmp"
                      prefix="$"
                      show-icon-required>
                    </gofix-form-input-number>
                  </b-col>
                  <b-col md="4">
                    <gofix-form-input label="Unit of Measurement" v-model="sorItem.unit_of_measurement" required></gofix-form-input>
                  </b-col>
                  <b-col md="4">
                    <!-- -->
                  </b-col>
                  <b-col md="4">
                    <b-row>
                      <b-col md="6">
                        <gofix-form-input-number
                          label="Minimum Quatity"
                          :includeThousandsSeparator="false"
                          v-model="sorItem.min_qty">
                        </gofix-form-input-number>
                      </b-col>
                      <b-col md="6">
                        <gofix-form-input-number
                          label="Maximum Quatity"
                          :includeThousandsSeparator="false"
                          v-model="sorItem.max_qty">
                        </gofix-form-input-number>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col md="4">
                    <b-row>
                      <b-col md="6">
                        <gofix-form-input-number
                          label="Warranty [Months]"
                          :includeThousandsSeparator="false"
                          :allowDecimal="false"
                          v-model="sorItem.warranty">
                        </gofix-form-input-number>
                      </b-col>
                      <b-col md="6">
                        <gofix-form-input label="Tag" v-model="sorItem.tag"></gofix-form-input>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </gofix-card>
            </b-form>
          </template>
          <template slot="gofixTab:versioning">
            <sor-versioning :sor-item-id="sorItem.id"></sor-versioning>
          </template>
        </gofix-tab>
      </b-col>
    </b-row>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  const sorVersioning = () => import('./versioning')
  export default {
    name: 'basicInfo',
    components: {
      'sor-versioning' : sorVersioning
    },
    data () {
      return {
        groups: [],
        tabData:[
          {
            key: "basic-info",
            title: "Basic Info",
            active: true
          }
        ],
        brands: []
      }
    },
    watch: {
      "sorItem": function (val) {
        if(val.id){
          this.sorItem.unit_price_tmp = this.$accounting.formatMoney(this.sorItem.unit_price);
          if(val.versionings && val.versionings.length > 0){
            this.tabData.push({
              key: "versioning",
              title: "Versioning",
              active: false
            });
          }
        }
      },
      ClientContractID: function(val, old){
        if(!val)
          return this.$router.push('/v2/contract-client');

        if(old && val && old.id && val.id && old.id != val.id)
          return this.$router.push(`/v2/contract-client/${val.id}/sor`);

        if(!this.sorGroupData) {
          this.$store.dispatch( 'v2SorController/getGroup', val.sor_group_root_id);
        }
      },
      sorGroupData: function (val) {
        if(val)
          this.groups = val;
      }
    },
    created () {
      //Check in C-contract
      if(!this.$route.params.hasOwnProperty('id') || isNaN(this.$route.params.id)) {
        return this.$router.push(`/v2/contract-client`);
      }

      if(this.ClientContractID && this.ClientContractID.sor_group_root_id){
        this.$store.dispatch( 'v2SorController/getGroup', this.ClientContractID.sor_group_root_id);
      }

      if(this.$route.params.sor_id != 0){
        this.$store.dispatch("v2SorController/getItem",this.$route.params.sor_id)
        .then(async response => {
          if(response.data.data.code && response.data.data.code == 400) {
            await this.$router.push(`/v2/contract-client/${this.$route.params.id}/sor`);
            await this.$alertNotification("Sor doesn't exist.", "danger");
          }
        });
      }

      if(this.sorGroupData)
        this.groups = this.sorGroupData;

      this.$store.dispatch('v2SorController/getService', { contract_id: this.$route.params.id, service_id: 0})
      .then(response => {
        this.Loadings.service = false;
      }).catch(error => {
        this.Loadings.service = false;
      });

      this.$store.dispatch('MasterBrandController/getItems', { page: 1, limit: -1, sortColumn: "name", sortDirection: "ASC", filter: {
        contract_id: null
      }}).then(result => {
        this.brands = result.items
      });
    },
    computed: {
      ...mapGetters({
        Loadings:     'v2SorController/Loadings',
        sorGroupData: 'v2SorController/Groups',
        sorItem:      'v2SorController/sorItem',
        Services:     'v2SorController/serviceCategories',
        Validate:     'v2SorController/Validate',
        ClientContractID: 'ContractController/ClientContractID',
      })
    },
    methods:{
      updateItem(){
        this.sorItem.unit_price = this.$accounting.unformat(this.sorItem.unit_price_tmp);
        let contract_term_id = this.sorItem.contract_term_id;
        if(!contract_term_id){
          contract_term_id = this.ClientContractID.contract_terms[0].id;
        }
        if(this.$route.params.sor_id) {
          this.sorItem.sor_group_id = this.sorItem.sor_group  ? this.sorItem.sor_group.id : null
        } else {
          this.sorItem.sor_group_id = this.sorItem.sor_group  ? this.sorItem.sor_group.id : this.ClientContractID.sor_group_root_id
        }
        this.sorItem.is_maintenance = false;
        this.$store.dispatch("v2SorController/checkValidate")
          .then(validate => {
            this.$store.dispatch("v2SorController/saveSorItem",contract_term_id).then( data => {
              this.$alertNotification(this.$notificationV2('editing', 'sor'));
              if(this.$route.params.sor_id == 0){
                this.$router.push({ name:"edit-sor",params: { sor_id:data.id }})
              }
            }).catch(err => {
              if(err.response && err.response.data && err.response.data.error && err.response.data.error.message){
                this.$alertNotification(err.response.data.error.message.error, "danger");
                return;
              }
              this.$alertNotification("An error occurred while saving the SOR item.", "danger");
            });
          })
          .catch(err => {
            this.$alertNotification("Please enter in required fields", "danger");
          })
      },
      loadOptionsService({ action, parentNode, callback,instanceId  }){
        if(parentNode.isBatch){
          this.$store.dispatch("v2SorController/getService",{
            contract_id:this.$route.params.id,
            service_id:parentNode.id
          }).then(data => {
            parentNode.children = data;
            callback()
          })
        }else{
          parentNode.children = undefined;
          callback()
        }
      },
      normalizerGroup(node) {
        if(node.children && node.children.length){
          return {
            label: node.text || node.description_one,
            id: node.data ? node.data.id : node.id,
          }
        }else{
          return {
            label: node.text || node.description_one,
            id: node.data ? node.data.id : node.id,
            children : undefined,
          }
        }
      },
      normalizerService(node) {
        if(node.data && !node.data.isBatch){
          return {
            children : undefined,
            label: node.name
          }
        }
        return {
          label: node.name
        }
      },
    }
  }
</script>
